"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounceTime = void 0;
exports.debounceTime = (function createDebounce() {
    var timeout;
    return function (callback, delayMs) {
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(function () {
            callback();
        }, delayMs || 500);
    };
})();
